import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Button } from "@jti/ui/components/Button/Button";
import QrCode from "@jti/ui/icons/qr-code.svg";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { ScanQrCodeDialog } from "./ScanQrCodeDialog/ScanQrCodeDialog";
import styles from "./ScanQrCode.module.scss";
/**
 * Works only in small and medium devices
 */
export const ScanQrCode = ({ handleScanQrCode, handleRegistrationCodeModalOpen }) => {
    const { __ } = useTranslations();
    const [isScanQrDialogOpened, setIsScanQrDialogOpened] = useState(false);
    const toggleScanQrCodeDialog = useCallback(() => {
        setIsScanQrDialogOpened((prevOpenedState) => !prevOpenedState);
    }, []);
    const onCodeDetect = useCallback((value) => {
        handleScanQrCode(value);
        toggleScanQrCodeDialog();
    }, [handleScanQrCode, toggleScanQrCodeDialog]);
    return (_jsxs("div", { className: styles.scanQrContainer, children: [_jsxs(Button, { "data-testid": "scanQR", className: styles.scanQrButton, onClick: toggleScanQrCodeDialog, color: "primary", children: [_jsx(QrCode, { className: styles.scanQrIcon }), __("auth.registration.device.scan_qr_button")] }), isScanQrDialogOpened && (_jsx(ScanQrCodeDialog, { isOpened: isScanQrDialogOpened, onToggle: toggleScanQrCodeDialog, onCodeValueDetect: onCodeDetect, handleRegistrationCodeModalOpen: handleRegistrationCodeModalOpen }))] }));
};
//# sourceMappingURL=ScanQrCode.js.map